import { useState, useEffect } from "react";
import { NamirasoftAPIProductServer, ProductFullRow } from "namirasoft-api-product";
import { NSCard } from "./NSCard";
import { EnvService } from 'namirasoft-core'
import { NSSection } from "./NSSection";

export interface NSListProductProps 
{
    scope: string;
    name: string;
}

interface NSListProductState
{
    products: ProductFullRow[];
}

export function NSListProduct(props: NSListProductProps)
{
    const [state, setState] = useState<NSListProductState>({ products: [] });

    useEffect(() =>
    {
        let REACT_APP_BASE_URL_API_PRODUCT = new EnvService("REACT_APP_BASE_URL_API_PRODUCT", true).getString();
        let server = new NamirasoftAPIProductServer(REACT_APP_BASE_URL_API_PRODUCT, () => { });
        server.filter.ListProducts(props.scope, props.name, null, null, null, []).then((products) =>
        {
            setState({ products: products.rows });
        }).catch(() => { });
    }, []);

    return (
        <NSSection style={{ gap: "16px" }}>
            {
                state.products.map((product: ProductFullRow) =>
                {
                    return (
                        <NSCard key={product.id} link={{ href: product.link ?? "" }} title={product.name} image={{ src: product.logo ?? '', alt: product.name }} />
                    );
                })
            }
        </NSSection>
    );
}